<template>
  <v-layout>
    <v-app-bar color="black" density="compact">
      <template v-slot:prepend>
        <v-app-bar-nav-icon @click="$router.push('/')"></v-app-bar-nav-icon>
      </template>
      <v-tabs v-if="screenWidth > 750">
        <router-link to="/"><v-tab>Home</v-tab></router-link>
        <router-link to="/stufen">
          <v-tab>Stufen</v-tab>
        </router-link>
        <router-link to="/team"><v-tab>Leitungsteam</v-tab></router-link>
        <router-link to="/mitmachen"><v-tab>Mitmachen</v-tab></router-link>
        <router-link to="/kontakt"><v-tab>Kontakt</v-tab></router-link>
        <router-link to="/spenden"><v-tab>Spenden</v-tab></router-link>
      </v-tabs>


      <template v-if="isMobile">
        <v-spacer></v-spacer>
        <v-btn icon aria-label="Menu" @click="drawer = !drawer">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" temporary location="right" theme="dark">
      <v-list>
        <v-list-item title="Home" value="/" @click="$router.push('/')"></v-list-item>
        <v-divider></v-divider>
        <v-list-item title="Stufen" value="/stufen" @click="$router.push('/stufen')"></v-list-item>
        <v-divider></v-divider>
        <v-list-item title="Leitungsteam" value="/team" @click="$router.push('/team')"></v-list-item>
        <v-divider></v-divider>
        <v-list-item title="Mitmachen" value="/mitmachen" @click="$router.push('/mitmachen')"></v-list-item>
        <v-divider></v-divider>
        <v-list-item title="Kontakt" value="/kontakt" @click="$router.push('/kontakt')"></v-list-item>
        <v-divider></v-divider>
        <v-list-item title="Spenden" value="/spenden" @click="$router.push('/spenden')"></v-list-item>
      </v-list>
    </v-navigation-drawer>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      screenWidth: typeof window !== 'undefined' ? window.innerWidth : 1024,
      drawer: false,
    };
  },
  computed: {
    isMobile() {
      return this.screenWidth <= 750;
    },
  },
  methods: {
    onResize() {
      this.screenWidth = window.innerWidth;
    },
    navigate(path) {
      this.drawer = false;
      this.$router.push(path);
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
  },
  beforeMount() {
    window.removeEventListener('resize', this.onResize);
  },
};
</script>

<style scoped>
a {
  color: white;
  text-decoration: none;
}

#app .v-app-bar-nav-icon {
  content: url("@/assets/HeiGeiLogo.svg");
}
</style>
